import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../../../global-config'
import { TosSuperscript } from '../../../../tos-superscripts'
import { productSearchAlgoliaAccessorGetOffersData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetOffersData'
import { productSearchAlgoliaAccessorGetPricingData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetPricingData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

type ProductSearchResultItemPriceContainerListPriceProps = {
  showDiscount: boolean
}
export const ProductSearchResultItemPriceContainerListPrice: FC<
  ProductSearchResultItemPriceContainerListPriceProps
> = ({ showDiscount = false }) => {
  const { superScripts } = useGlobalConfigContext()
  const { algoliaRecord, isMarketplace } = useProductSearchResultItemContext()
  const { bestOffer, isSaeOffer } = productSearchAlgoliaAccessorGetOffersData(
    algoliaRecord,
    isMarketplace,
  )

  const { isListPricePresent, isPriceStrikedThrough, listPriceFormatted } =
    productSearchAlgoliaAccessorGetPricingData(algoliaRecord)

  const listPriceFormattedToShow = isSaeOffer
    ? listPriceFormatted
    : bestOffer?.strike_price?.formatted

  return isListPricePresent && listPriceFormattedToShow && showDiscount ? (
    <div className="text-dark-primary-max">
      <span className="mr-1">
        {isSaeOffer ? (
          <FormattedMessage id="general.label.listPrice" />
        ) : (
          <FormattedMessage id="general.label.miraklListPrice" />
        )}
        <TosSuperscript value={superScripts.avp} />
      </span>

      <span className={clsx(isPriceStrikedThrough && 'line-through')}>
        {listPriceFormattedToShow}
      </span>
    </div>
  ) : null
}
